import type { FeatureFlagConfig } from '@platform/client/features';

declare module '@platform/core/feature-flags' {
  interface FeatureFlags {
    SCAN_SCHEDULES_TABLE_V2?: boolean;
    SCANNER_CONFIGURE_ACTIVATE?: boolean;
    SCANNER_TABLE_DATAGRID?: boolean;
    SSC_SELF_SERVICE_UPGRADE_RBAC_BYPASS?: boolean;
    SSC_SELF_SERVICE_UPGRADE?: boolean;
    SHOW_AGENT_GROUPING?: boolean;
    AGENT_INTERNAL_CONFIG_V2?: boolean;
    SHOW_AGENT_SETTINGS_PAGE?: boolean;
    SCANNER_ERR_BANNER?: boolean;
    AGENTS_MODULE_INSTALLATION?: boolean;
    CLOUD_SCANNERS_CSPM?: boolean;
  }
}

export default {
  featureFlags: {
    SCAN_SCHEDULES_TABLE_V2: undefined,
    // Foxhound
    SSC_SELF_SERVICE_UPGRADE: undefined,
    SSC_SELF_SERVICE_UPGRADE_RBAC_BYPASS: undefined,
    // S2CX-4939 - Scanner Configure and Activate
    SCANNER_CONFIGURE_ACTIVATE: true,
    SCANNER_TABLE_DATAGRID: true,
    SHOW_AGENT_SETTINGS_PAGE: true,
    AGENT_INTERNAL_CONFIG_V2: undefined,
    SHOW_AGENT_GROUPING: undefined,
    // AWN-226899 - Check recent Scanner jobs for issues
    SCANNER_ERR_BANNER: undefined,
    // AWN-173958
    AGENTS_MODULE_INSTALLATION: true,
    CLOUD_SCANNERS_CSPM: undefined,
  },
} satisfies FeatureFlagConfig;
